import { Box, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

/**
 * LightBoxImageArea — displays current image with prev/next nav and scroll zoom.
 * @param {object} props
 * @param {object} props.doc - current document { url, fileName }
 * @param {number} props.rotation - current rotation in degrees from local LightBox state
 * @param {number} props.scale - current zoom scale
 * @param {number} props.index - current index in documents array
 * @param {number} props.total - total number of documents
 * @param {Function} props.onPrev
 * @param {Function} props.onNext
 * @param {Function} props.onWheel
 */
export default function LightBoxImageArea({ doc, rotation, scale, index, total, onPrev, onNext, onWheel }) {
    return (
        <Box id="lightbox-image-area" className="lightbox-image-area" onWheel={onWheel}>
            {total > 1 && (
                <IconButton onClick={onPrev} disabled={index === 0} className="lightbox-nav lightbox-nav-prev">
                    <ChevronLeftIcon />
                </IconButton>
            )}

            <img
                src={doc.url}
                alt={doc.fileName}
                className="lightbox-image"
                // CHANGED — rotation from local state, scale from wheel handler
                style={{ transform: `rotate(${rotation}deg) scale(${scale})` }}
            />

            {total > 1 && (
                <IconButton onClick={onNext} disabled={index === total - 1} className="lightbox-nav lightbox-nav-next">
                    <ChevronRightIcon />
                </IconButton>
            )}
        </Box>
    );
}
